import axios from 'axios';

import { API_BASE_URL } from '../config';

export const peopleSearchService = {
  async searchProfiles(query) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/people/search`, {
        query,
        jobId: localStorage.getItem('currentJobId') || null
      });
      return response.data;
    } catch (error) {
      console.error('Error searching profiles:', error);
      throw error;
    }
  },

  async processCandidate(rawPersonData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/people/process`, {
        raw_person_data: rawPersonData
      });
      return response.data;
    } catch (error) {
      console.error('Error processing candidate:', error);
      throw error;
    }
  },

  async evaluateProfile(profile) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/people/evaluate`, {
        profile,
        jobId: localStorage.getItem('currentJobId') || null
      });
      return response.data;
    } catch (error) {
      console.error('Error evaluating profile:', error);
      throw error;
    }
  },

  async performAction(action, profile) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/people/action`, {
        action,
        profile,
        jobId: localStorage.getItem('currentJobId') || null
      });
      return response.data;
    } catch (error) {
      console.error('Error performing action:', error);
      throw error;
    }
  },
};
